<div
  class="modal fade"
  [class.show]="mostrarModal"  
  id="modalSemCreditos"
  tabindex="-1"
  aria-labelledby="modalSemCreditosLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title fs-5" id="exampleModalLabel">Recarregar Créditos</h3>
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="color: #0070C0;">
        <p class="text-center"><b>Atenção! Seus créditos chegaram ao fim.</b></p>
        <p class="text-center">
            Não se preocupe! Estamos te direcionando para a área de recargas. Escolha a quantidade de créditos, a forma de
            pagamento e continue aproveitando todos os recursos do <b>Atalho</b>. 🚀
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="navegarParaRecarga($event)">Confirmar</button>
      </div>
    </div>
  </div>
</div>